import ProfileIndex from "./screens/ProfileIndex"

const rootPath = 'myaccount'
export const myAccountRoutes = [
    {
        path: rootPath,
        element: <ProfileIndex />,
        isProtected: true
    },
]